import User from '@/models/User'
import Paginator from '@/models/Paginator'
import Overview from '@/models/User/Overview'
import { user as backend } from '@/api'
import { common as pathLoader } from '@/api'
import { findIndex } from 'lodash'

export default {

  namespaced: true,

  state: {
    user: new User,
    users: new Paginator,
    user_list: [],
    overview: {
      current_month: new Overview(),
      last_month: new Overview(),
      all_time: new Overview(),
    },
  },

  mutations: {
    clear: (state) => state.user = new User,
    clearUsers: (state) => state.users = new Paginator,
    setUser: (state, payload) => state.user = payload,
    setUsers: (state, payload) => state.users = payload,
    setUserList: (state, payload) => state.user_list = payload,
    setUserProfilePicture: (state, payload) => state.user.profile.picture_url = payload,
    pushUser: (state, payload) => state.users.data.push(payload),
    name: (state, payload) => state.user.name = payload,
    surname: (state, payload) => state.user.surname = payload,
    full_name: (state, payload) => state.user.full_name = payload,
    email: (state, payload) => state.user.email = payload,
    mobile: (state, payload) => state.user.profile.mobile = payload,
    setOverview: (state, payload) => state.overview = payload,
    allowAbility: (state, payload) => state.user.abilities.push(payload),
    disallowAbility: (state, payload) => {
      let index = state.user.abilities.indexOf(payload)
      state.user.abilities.splice(index, 1)
    },
    disableUser: (state) => state.user.is_active = false,
    reactivateUser: (state) => state.user.is_active = true,
  },

  actions: {
    save: ({ state }) => new Promise((resolve, reject) => {
      (state.user.id) ? backend.update(
        state.user,
        ({ data }) => resolve(data),
        error => reject(error)
      ) : backend.store(
        state.user,
        ({ data }) => resolve(data),
        error => reject(error)
      )
    }),
    loadUsers: ({ commit }, payload) => new Promise((resolve, reject) => {
      pathLoader.loadPath(payload, ({ data }) => {
        commit('setUsers', data)
        resolve()
      }, error => reject(error))
    }),
    loadList: ({ commit }) => new Promise((resolve, reject) => {
      backend.loadList(({ data }) => {
        commit('setUserList', data)
        resolve()
      }, error => reject(error))
    }),
    loadUser: ({ commit }, userId) => new Promise((resolve, reject) => {
      backend.loadUser(userId, ({ data }) => {
        commit('setUser', data)
        resolve()
      }, error => reject(error))
    }),
    loadOverview: ({ commit }, userId) => new Promise((resolve, reject) => {
      backend.loadOverview(userId, ({ data }) => {
        commit('setOverview', data)
        resolve()
      }, error => reject(error))
    }),
    uploadProfilePicture: ({ commit, state }, picture) => new Promise((resolve, reject) => {
      backend.uploadProfilePicture({
        picture,
        userId: state.user.id
      }, ({ data }) => {
        commit('setUserProfilePicture', data)
        resolve()
      }, error => reject(error))
    }),
    allowAbility: ({ state }, ability) => new Promise((resolve, reject) => {
      backend.allowAbility({
        user: state.user.id,
        ability
      }, response => {
        resolve()
      }, reject)
    }),
    disallowAbility: ({ state }, ability) => new Promise((resolve, reject) => {
      backend.disallowAbility({
        user: state.user.id,
        ability
      }, response => {
        resolve()
      }, reject)
    }),
    disableUser: ({ commit }, userId) => new Promise((resolve, reject) => {
      commit('disableUser')
      backend.disableUser(userId, response => {
        resolve()
      }, error => reject(error))
    }),
    reactivateUser: ({ commit }, userId) => new Promise((resolve, reject) => {
      commit('reactivateUser')
      backend.reactivateUser(userId, response => {
        resolve()
      }, error => reject(error))
    })
  },

  getters: {
    user: state => state.user,
    users: state => state.users,
    userList: state => state.user_list,
    overview: state => state.overview,
  }
}
